import React, { FC, useRef, forwardRef } from "react";
import MaterialTable from "material-table";
import { localizationJapanese } from "../../common/MatelialTableLocalizationJapanese";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import {
  Grid,
  Link,
  TablePagination,
  Typography,
} from "@material-ui/core";
import RemoveIcon from "@material-ui/icons/Remove";
import { DateTime } from "luxon";
import {
  getFirstDayOfMonth,
  getLastDayOfMonth,
} from "../Register/TSCheckTableDataOperation";
import { userLogging } from "../../../apis/userLog";
import { useHistory } from "react-router-dom";

import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import CloseIcon from "@material-ui/icons/Close";

const TAB_INDEX_STORE = 3;

const TSCheckManagerAnalysisSepticTank: FC<{
  data: any[] | undefined;
  headerName: string;
  tableSubmissionHeaderList: string[];
  tabValue: number;
  smallFlg: boolean;
  smallData: any[];
}> = ({
  data,
  headerName,
  tableSubmissionHeaderList,
  tabValue,
  smallFlg,
  smallData,
}) => {
  const tableRef: any = useRef();
  const [sortNo, setSortNo] = React.useState(0);
  const [orderDirection, setOrderDirection] = React.useState<
    "desc" | "asc" | undefined
  >(undefined);
  const history = useHistory();
  const [sortMode, setSortMode] = React.useState(0);

  function convertIcons(check: string) {
    if (!check) return "";
    if (check === "1") {
      return (<RadioButtonUnchecked/>)
    }
    else if (check === "2") {
      return (<CloseIcon/>)
    }
    return (<RemoveIcon/>)
  }

  // "yyyymmdd"を"yyyy-mm-dd"に変換する
  const formatDateString = (date: string) => {
    if (!date) return "";
    const formatedDate =
      date.slice(0, 4) + "/" + date.slice(4, 6) + "/" + date.slice(6);
    return (<Typography variant="h6">{formatedDate}</Typography>);
  };

  const getColumnsList = () => {
    let resultList: any[] = [];
    const ofcColumn = {
      title: "OFC",
      field: "ofcName",
      cellStyle: {
        width: "192px",
      },
      sorting: false,
      render: (rowData: any) => {
        return rowData.ofcName;
      },
    };
    const nameColumn = {
      title: headerName,
      field: "name",
      cellStyle: {
        width: "300px",
      },
      sorting: false,
      render: (rowData: any) => {
        // 店舗名
        return (
          rowData.name
        );
      },
    };
    const monthColumn: Array<any> = [];
    let clnTitle = ["浄化槽設置状況", "法定点検有無", "法定点検実施日", "検査結果", "検査報告書日付"];
    for (let i = 0; i < 5; i++) {
      const diffNo = i + 1;
      const diff = diffNo + "wDiff";
      const diffBase = diffNo + "wDiffBase";
      const tableHedder = clnTitle[i];
      monthColumn.push({
        title: tableHedder,
        field: tableHedder,
        align: "center",
        type: "numeric",
        defaultSort:
          sortNo === i + 2 && orderDirection ? orderDirection : undefined,
        customSort: (a: any, b: any) => {
          return sortMode === 1 && !(smallFlg && tabValue === TAB_INDEX_STORE)
            ? a[diffBase] || a[diffBase] === 0
              ? Number(a[diffBase]) - Number(b[diffBase])
              : Number(a[diff]) - Number(b[diff])
            : Number(a[tableHedder]) - Number(b[tableHedder]);
        },
        render: (rowData: any) => {
          let clnData = [
            convertIcons(rowData.septicTankValue),
            convertIcons(rowData.inspectionValue),
            formatDateString(rowData.inspectionDay),
            convertIcons(rowData.confirmationValue),
            formatDateString(rowData.confirmationDay)
          ];
          return clnData[i];
        },
      });
    }

    // 提出数カラム
    // 提出数カラムはOFC分析(tabValue === 2)の場合のみ出力
    const submissionColumn: Array<any> = [];
    for (let i = 0; i < 5; i++) {
      submissionColumn.push({
        title: "",
        field: tableSubmissionHeaderList[i],
        maxWidth: 300,
        sorting: false,
        align: "left",
        render: (rowData: any) => {
          return rowData[tableSubmissionHeaderList[i]] !== "0" ? (
            <Link
              style={{ cursor: "pointer" }}
              onClick={() =>
                clickSubmissionsCount(
                  tableSubmissionHeaderList[i],
                  rowData["ofc_mailaddress"]
                )
              }
              color="primary"
            >
              {rowData[tableSubmissionHeaderList[i]]}&#047;
              {rowData["tenpo_count"]}
            </Link>
          ) : (
            <>
              {rowData[tableSubmissionHeaderList[i]]}&#047;
              {rowData["tenpo_count"]}
            </>
          );
        },
      });
    }

    resultList.push(ofcColumn);
    resultList.push(nameColumn);
    for (let i = 0; i < 5; i++) {
      resultList.push(monthColumn[i]);
    }
    return resultList;
  };

  // 対象OFCの店舗の検索に遷移
  const clickSubmissionsCount = (dateString: any, ofcAddress: string) => {
    const targetDateTime = DateTime.fromFormat(dateString, "yyyy/MM/dd");
    const jsDate = targetDateTime.toJSDate();
    const fromDate: DateTime = DateTime.fromFormat(
      getFirstDayOfMonth(jsDate.toISOString(), 0),
      "yyyyMMdd"
    );
    const toDate: DateTime = DateTime.fromFormat(
      getLastDayOfMonth(jsDate.toISOString(), 1),
      "yyyyMMdd"
    );

    const paramState = {
      ofcAddress: ofcAddress,
      createdateFrom: fromDate,
      createdateTo: toDate,
    };
    history.push({
      pathname: "ts-check-search",
      state: paramState,
    });
    userLogging("店舗衛生点検", "管理者分析#検索画面へ遷移", "データ検索");
  };

  return (
    <Grid container justify="center" alignItems="center">
      <Grid container justify="center" alignItems="center">
        <MaterialTable
          tableRef={tableRef}
          data={
            !smallFlg
              ? JSON.parse(JSON.stringify(data))
              : JSON.parse(JSON.stringify(smallData))
          }
          columns={getColumnsList()}
          style={{ width: "90%" }}
          components={{
            Pagination: (props) => (
              <TablePagination {...props} rowsPerPageOptions={[5, 10, 15]} />
            ),
          }}
          icons={{
            Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
            Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
            Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
            Delete: forwardRef((props, ref) => (
              <DeleteOutline {...props} ref={ref} />
            )),
            DetailPanel: forwardRef((props, ref) => (
              <ChevronRight {...props} ref={ref} />
            )),
            Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
            Export: forwardRef((props, ref) => (
              <SaveAlt {...props} ref={ref} />
            )),
            Filter: forwardRef((props, ref) => (
              <FilterList {...props} ref={ref} />
            )),
            FirstPage: forwardRef((props, ref) => (
              <FirstPage {...props} ref={ref} />
            )),
            LastPage: forwardRef((props, ref) => (
              <LastPage {...props} ref={ref} />
            )),
            NextPage: forwardRef((props, ref) => (
              <ChevronRight {...props} ref={ref} />
            )),
            PreviousPage: forwardRef((props, ref) => (
              <ChevronLeft {...props} ref={ref} />
            )),
            ResetSearch: forwardRef((props, ref) => (
              <Clear {...props} ref={ref} />
            )),
            Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
            SortArrow: forwardRef((props, ref) => (
              <ArrowDownward {...props} ref={ref} />
            )),
            ThirdStateCheck: forwardRef((props, ref) => (
              <Remove {...props} ref={ref} />
            )),
            ViewColumn: forwardRef((props, ref) => (
              <ViewColumn {...props} ref={ref} />
            )),
          }}
          // onOrderChange={(orderBy: number, orderDirection: "asc" | "desc") => {
          //   // OFC別分析タブのカラム数のズレを補正
          //   // if (tabValue === TAB_INDEX_OFC) {
          //   //   if (orderBy === 4) {
          //   //     orderBy = 3;
          //   //   } else if (orderBy === 6) {
          //   //     orderBy = 4;
          //   //   } else if (orderBy === 8) {
          //   //     orderBy = 5;
          //   //   } else if (orderBy === 10) {
          //   //     orderBy = 6;
          //   //   }
          //   // }
          //   // // 個店別別分析タブのカラム数のズレを補正
          //   // else if (tabValue === TAB_INDEX_STORE) {
          //     orderBy = orderBy - 1;
          //   // }
          //   setSortNo(orderBy);
          //   setOrderDirection(orderDirection);
          // }}
          localization={localizationJapanese}
          options={{
            padding: "dense",
            draggable: false,
            search: false,
            showTitle: false,
            toolbar: false,
            filtering: false,
            paging: false,
            // 対象外の場合はcsv出力ボタン非表示
            exportButton: false,
            headerStyle: {
              backgroundColor: "#4dc0b2",
              color: "#ffffff",
              whiteSpace: "nowrap",
              paddingLeft: "14px",
              paddingRight: "14px",
            },
            rowStyle: {
              fontSize: "12px",
              whiteSpace: "nowrap",
            },
          }}
        ></MaterialTable>
      </Grid>
    </Grid>
  );
};

export default TSCheckManagerAnalysisSepticTank;
